export default function(filename, res) {
  console.log(filename, res);
  const disposition = res.headers["content-disposition"];
  if (disposition) {
    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    if (matches !== null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
      // 针对文件名中含有中文的场景，需要解码
      filename = decodeURIComponent(filename);
    }
  }
  const blob = new Blob([res.data], { type: res.data.type }); // 通过返回的流数据 手动构建blob 流
  const reader = new FileReader();
  reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签的href （转换base64还可用 window.atob ，未实验过）
  reader.onload = e => {
    // 转换完成，创建一个a标签用于下载
    const a = document.createElement("a");
    a.download = filename; // 构建 下载的文件名称以及下载的文件格式（可通过传值输入）
    if (typeof e.target.result === "string") {
      a.href = e.target.result;
    }
    a.click();
  };
}
